import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import cellTemplate from './status.pug';
import headerTemplate from './status-header.pug';

export class ColumnStatus extends CampaignuiBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'UiDisplayStatus',
      property: 'UiDisplayStatus',
      sortable: 'UiDisplayStatus',
      title: i18n.getString('ColumnName_Status'),
      type: 'string',
      bodyClasses: 'grid-column-AssetStatus',
      headerTemplate: () => headerTemplate({}),
      i18n,
    });
  }

  get property() {
    return {
      get: ({ UiDisplayStatus }) => ({
        status: UiDisplayStatus,
        label: this.config.i18n.getString(`AssetLink_Status_${UiDisplayStatus}`),
      }),
    };
  }

  template({ value }) {
    return cellTemplate(value);
  }
}
